// tools/article_images.py post_process (IMAGES.md §1): the fetch server's marker lines → paragraphs, quote indexes
// and images anchored before a paragraph.

export interface ArticleImage { src: string; alt: string; caption: string; width: number; height: number; before: number }

const MARKER = /^(\d+)$/;
const QUOTE = "";

export function postProcess(raw: string[], rawImages: any[] | null | undefined) {
  const paragraphs: string[] = [], quotes: number[] = [], images: ArticleImage[] = [];
  const seen = new Set<string>();
  const imgs = rawImages || [];
  for (const line of raw) {
    const m = MARKER.exec(line.trim());
    if (m) {
      const n = parseInt(m[1], 10);
      if (n < imgs.length) {
        const img = imgs[n] || {};
        const src = img.src || "";
        if (src && !seen.has(src)) {
          seen.add(src);
          images.push({ src, alt: img.alt || "", caption: img.caption || "", width: Math.trunc(Number(img.width) || 0),
            height: Math.trunc(Number(img.height) || 0), before: paragraphs.length });
        }
      }
      continue;
    }
    const isQuote = line.includes(QUOTE);
    let p = line.replaceAll(QUOTE, "");
    if (isQuote) p = p.replace(/\s+/g, " ");
    p = p.trim();
    if (!p) continue;
    if (isQuote) quotes.push(paragraphs.length);
    paragraphs.push(p);
  }
  return { paragraphs, quotes, images };
}
